<script>

    import FloatingMenuRow from './FloatingMenuRow.svelte';
    import { floatingMenuRowTypes } from '@repo/config/Global';
    import FloatingMenuSectionTitleRow from './FloatingMenuSectionTitleRow.svelte';
    import FloatingMenuCheckBoxRow from './FloatingMenuCheckBoxRow.svelte';
    import FloatingMenuColorRow from './FloatingMenuColorRow.svelte';
    import FloatingMenuRadioSelectRow from './FloatingMenuRadioSelectRow.svelte';
    import FloatingMenuSizeRow from './FloatingMenuSizeRow.svelte';
    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {any} [items]
     * @property {boolean} [noAriaRole]
     * @property {boolean} [ariaListBox]
     * @property {boolean} [asMenu]
     */
    let {
        items = [],
        noAriaRole = false,
        ariaListBox = false,
        asMenu = false
    } = $props();
    
    const dispatch = createEventDispatcher();

    function handleMenuRowClick(e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        if (e.detail) {
            dispatch('click', {
                action: e.detail.action || e.detail, 
                originalDataSet: e.detail.dataSet || {}, 
                label: e.detail.label
            });
        } else {
            dispatch('click', e);
        }
    }
</script>

{#each items as row}
    {#if row.type === floatingMenuRowTypes.SECTION_TITLE}
        <FloatingMenuSectionTitleRow label={row.label} />
    {:else if row.type === floatingMenuRowTypes.CHECK_BOX}
        <FloatingMenuCheckBoxRow on:click={handleMenuRowClick} name={row.name || row.label} label={row.label} checked={row.checked} action={row.action} noAriaRole={noAriaRole || asMenu} role={ariaListBox ? 'option' : null} disabled={row.disabled} />
    {:else if row.type === floatingMenuRowTypes.RADIO_SELECT}
        <FloatingMenuRadioSelectRow on:click={handleMenuRowClick} label={row.label} checked={row.checked} action={row.action} noAriaRole={noAriaRole || asMenu} role={ariaListBox ? 'option' : null} />
    {:else if row.type === floatingMenuRowTypes.COLOR}
        <FloatingMenuColorRow on:click={handleMenuRowClick} action={row.action} currentColor={row.currentColor} colors={row.colors} noAriaRole={noAriaRole || asMenu} role={ariaListBox ? 'option' : null} />
    {:else if row.type === floatingMenuRowTypes.SIZE}
        <FloatingMenuSizeRow on:click={handleMenuRowClick} action={row.action} currentSize={row.currentSize} noAriaRole={noAriaRole || asMenu} role={ariaListBox ? 'option' : null} />
    {:else}
        <FloatingMenuRow on:click={handleMenuRowClick} label={row.label} action={row.action} icon={row.icon} confirm={row.confirm} align={row.align} active={row.active} noAriaRole={noAriaRole || asMenu} role={ariaListBox ? 'option' : null} as={!ariaListBox && !asMenu && items.length === 1 ? 'div' : 'li'} {asMenu} />
    {/if}
{/each}